export const BUYER_JOURNEY = {
  GRAPH_DATA_LOAD: 'BUYER_JOURNEY_GRAPH_DATA_LOAD',
  GRAPH_DATA_SUCCESS: 'BUYER_JOURNEY_GRAPH_DATA_SUCCESS',
  GRAPH_DATA_FAIL: 'BUYER_JOURNEY_GRAPH_DATA_FAIL',
  GRAPH_DATA_RESET: 'BUYER_JOURNEY_GRAPH_DATA_RESET',
  CONTACTS_OVERVIEW_LOAD: 'BUYER_JOURNEY_CONTACTS_OVERVIEW_LOAD',
  CONTACTS_OVERVIEW_SUCCESS: 'BUYER_JOURNEY_CONTACTS_OVERVIEW_SUCCESS',
  CONTACTS_OVERVIEW_FAIL: 'BUYER_JOURNEY_CONTACTS_OVERVIEW_FAIL',
  CONTACTS_OVERVIEW_RESET: 'BUYER_JOURNEY_CONTACTS_OVERVIEW_RESET',
  SCORING_CRITERIA_LOAD: 'BUYER_JOURNEY_SCORING_CRITERIA_LOAD',
  SCORING_CRITERIA_SUCCESS: 'BUYER_JOURNEY_SCORING_CRITERIA_SUCCESS',
  SCORING_CRITERIA_FAIL: 'BUYER_JOURNEY_SCORING_CRITERIA_FAIL',
  SCORING_CRITERIA_RESET: 'BUYER_JOURNEY_SCORING_CRITERIA_RESET',
  EXPORT_POPUP_OPEN: 'BUYER_JOURNEY_EXPORT_POPUP',
  EXPORT_BUTTON_LOAD: 'BUYER_JOURNEY_EXPORT_BUTTON_LOAD',
  SET_TRACKING_ID: 'BUYER_JOURNEY_SET_TRACKING_ID',
  RESET_TRACKING_ID: 'BUYER_JOURNEY_RESET_TRACKING_ID',
  BUYER_JOURNEY_SCORING_CRITERIA_UPDATED: 'BUYER_JOURNEY_SCORING_CRITERIA_UPDATED',
};
